// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Wnay","content":"ManualTimeModal_content__2kKf0"};